import { Vocabulary } from "../Vocabulary";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";

export const ROUTER_MANAGE_TASKURI = {
  routes: ["/tasks-backlog", "*"],
};

export const MAIN_SLIDER_MANAGE_TASKURI = [
  {
    name: Vocabulary.tasksName,
    path: "/tasks-backlog",
    icon: <AssignmentTurnedInIcon />,
    orderId: 3,
    group: Vocabulary.navGroupNavigation,
  },
];

export const VEHICLE_OPTIONS_MANAGE_TASKURI = [];

export const DINAMIC_TABS_MANAGE_TASKURI = { 
  // add: true 
};

export const MAIN_TABLE_MANAGE_TASKURI = null;

export const TASK_FORM_ASSIGN_TASKS = {
  canAssignTasks: true,
};
